{
  "familyId": "GELD-WISSELEN",
  "questions": [
    {
      "id": "GELD-WISSELEN-001", "familyId": "GELD-WISSELEN", "module": "Geld", "tier": 9, "levelCode": "M7", "group": 7, "skill": "geld_basis", "subSkill": "geld_valuta", "questionType": "multiple_choice",
      "question": "1 euro is 1,10 dollar. Hoeveel dollar krijg je voor 50 euro?",
      "options": ["55 dollar", "50 dollar", "45 dollar", "60 dollar"], "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Valuta omrekenen", "content": "Vermenigvuldig het bedrag met de wisselkoers. 50 × 1,10 = 55 dollar.", "icon": "lightbulb" } }],
      "conceptId": "valuta_basis", "variantIndex": 1, "citoDifficulty": 0.32, "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "WISSEL-MC-NO-CONVERSION", "label": "Denkt dat 1 euro = 1 dollar", "optionIndex": 1 },
          { "id": "WISSEL-MC-DIVIDE-INSTEAD", "label": "Deelt in plaats van vermenigvuldigt", "optionIndex": 2 },
          { "id": "WISSEL-MC-WRONG-RATE", "label": "Gebruikt verkeerde wisselkoers (1,20 i.p.v. 1,10)", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "1 euro = 1,10 dollar. Voor 50 euro: 50 × 1,10 = 55 dollar.",
        "solutionSteps": ["Wisselkoers: 1 euro = 1,10 dollar", "Vermenigvuldig: 50 × 1,10", "50 × 1 = 50, 50 × 0,10 = 5", "50 + 5 = 55 dollar"],
        "distractorExplanations": { "0": "Goed! 50 × 1,10 = 55 dollar.", "1": "Je dacht waarschijnlijk dat 1 euro = 1 dollar is. Maar de wisselkoers is 1,10. Vermenigvuldig: 50 × 1,10 = 55.", "2": "Je dacht waarschijnlijk dat je moet delen. Maar je gaat van euro naar dollar, en 1 euro = 1,10 dollar (meer), dus je vermenigvuldigt.", "3": "Je dacht waarschijnlijk dat 50 × 1,10 = 60 is. Maar 50 × 1,10 = 50 + 5 = 55. Controleer: 50 × 1,2 zou 60 zijn." }
      }
    },
    {
      "id": "GELD-WISSELEN-002", "familyId": "GELD-WISSELEN", "module": "Geld", "tier": 9, "levelCode": "M7", "group": 7, "skill": "geld_basis", "subSkill": "geld_valuta", "questionType": "multiple_choice",
      "question": "1 Brits pond = 1,15 euro. Je hebt 20 pond. Hoeveel euro is dat?",
      "options": ["€23,00", "€20,00", "€17,39", "€21,15"], "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Van vreemde valuta naar euro", "content": "Als 1 pond = 1,15 euro, dan vermenigvuldig je het aantal ponden met 1,15. 20 × 1,15 = 23,00 euro.", "icon": "lightbulb" } }],
      "conceptId": "valuta_naar_euro", "variantIndex": 2, "citoDifficulty": 0.35, "citoDiscrimination": 0.73,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "WISSEL-MC-NO-CONVERSION", "label": "Denkt dat 1 pond = 1 euro", "optionIndex": 1 },
          { "id": "WISSEL-MC-DIVIDE-INSTEAD", "label": "Deelt in plaats van vermenigvuldigt (20 ÷ 1,15)", "optionIndex": 2 },
          { "id": "WISSEL-MC-ADD-RATE", "label": "Telt wisselkoers op in plaats van vermenigvuldigen", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "1 pond = 1,15 euro. Voor 20 pond: 20 × 1,15 = 23,00 euro.",
        "solutionSteps": ["Wisselkoers: 1 pond = 1,15 euro", "Vermenigvuldig: 20 × 1,15", "20 × 1 = 20, 20 × 0,15 = 3", "20 + 3 = €23,00"],
        "distractorExplanations": { "0": "Goed! 20 × 1,15 = €23,00.", "1": "Je dacht waarschijnlijk dat 1 pond = 1 euro is. Maar 1 pond is meer waard: 1,15 euro. Vermenigvuldig: 20 × 1,15 = 23.", "2": "Je dacht waarschijnlijk dat je moet delen (20 ÷ 1,15). Maar je gaat van pond naar euro, en 1 pond = 1,15 euro (meer), dus vermenigvuldig.", "3": "Je dacht waarschijnlijk dat je 1,15 erbij optelt. Maar je vermenigvuldigt: 20 × 1,15 = 23, niet 20 + 1,15 = 21,15." }
      }
    },
    {
      "id": "GELD-WISSELEN-003", "familyId": "GELD-WISSELEN", "module": "Geld", "tier": 9, "levelCode": "M7", "group": 7, "skill": "geld_basis", "subSkill": "geld_valuta", "questionType": "multiple_choice",
      "question": "1 euro = 130 Japanse yen. Een speelgoed kost 2600 yen. Hoeveel euro is dat?",
      "options": ["€20", "€2600", "€200", "€26"], "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Van yen naar euro", "content": "Als 1 euro = 130 yen, dan deel je het bedrag in yen door 130. 2600 ÷ 130 = 20 euro.", "icon": "lightbulb" } }],
      "conceptId": "valuta_delen", "variantIndex": 3, "citoDifficulty": 0.40, "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "WISSEL-MC-NO-CONVERSION", "label": "Denkt dat yen en euro gelijk zijn", "optionIndex": 1 },
          { "id": "WISSEL-MC-WRONG-DIVISOR", "label": "Deelt door 13 in plaats van 130", "optionIndex": 2 },
          { "id": "WISSEL-MC-DIVIDE-BY-100", "label": "Deelt door 100 in plaats van 130", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "1 euro = 130 yen. Om van yen naar euro te gaan, deel je: 2600 ÷ 130 = 20 euro.",
        "solutionSteps": ["Wisselkoers: 1 euro = 130 yen", "Van yen naar euro: delen", "2600 ÷ 130 = 20", "Het speelgoed kost €20"],
        "distractorExplanations": { "0": "Goed! 2600 ÷ 130 = €20.", "1": "Je dacht waarschijnlijk dat 2600 yen = 2600 euro is. Maar yen is veel minder waard dan euro. Je moet delen: 2600 ÷ 130 = 20.", "2": "Je dacht waarschijnlijk dat je door 13 deelt in plaats van 130. Maar 1 euro = 130 yen, niet 13. 2600 ÷ 130 = 20.", "3": "Je dacht waarschijnlijk dat je door 100 deelt. Maar de wisselkoers is 130, niet 100. 2600 ÷ 130 = 20." }
      }
    },
    {
      "id": "GELD-WISSELEN-004", "familyId": "GELD-WISSELEN", "module": "Geld", "tier": 9, "levelCode": "M7", "group": 7, "skill": "geld_basis", "subSkill": "geld_valuta", "questionType": "multiple_choice",
      "question": "Je gaat op vakantie naar de VS. 1 euro = 1,10 dollar. Je wilt 100 dollar meenemen. Hoeveel euro heb je nodig?",
      "options": ["Ongeveer €91", "€110", "€100", "€90"], "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Hoeveel euro nodig?", "content": "Je wilt dollar kopen. 1 euro = 1,10 dollar. Dus: 100 ÷ 1,10 ≈ 90,91 euro. Je hebt ongeveer €91 nodig.", "icon": "lightbulb" } }],
      "conceptId": "valuta_terugrekenen", "variantIndex": 4, "citoDifficulty": 0.45, "citoDiscrimination": 0.69,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "WISSEL-MC-MULTIPLY-INSTEAD", "label": "Vermenigvuldigt in plaats van deelt (100 × 1,10)", "optionIndex": 1 },
          { "id": "WISSEL-MC-NO-CONVERSION", "label": "Denkt dat 100 dollar = 100 euro", "optionIndex": 2 },
          { "id": "WISSEL-MC-ROUNDING-ERROR", "label": "Rondt te vroeg of verkeerd af", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Je wilt 100 dollar. 1 euro = 1,10 dollar. Deel: 100 ÷ 1,10 ≈ 90,91 ≈ €91.",
        "solutionSteps": ["Je wilt 100 dollar", "1 euro = 1,10 dollar", "Deel: 100 ÷ 1,10 ≈ 90,91", "Je hebt ongeveer €91 nodig"],
        "distractorExplanations": { "0": "Goed! 100 ÷ 1,10 ≈ €91.", "1": "Je dacht waarschijnlijk dat je vermenigvuldigt: 100 × 1,10 = 110. Maar je gaat van dollar naar euro, en 1 euro > 1 dollar, dus je hebt MINDER euro nodig.", "2": "Je dacht waarschijnlijk dat 1 euro = 1 dollar is. Maar 1 euro = 1,10 dollar. Je hebt minder dan 100 euro nodig.", "3": "Je dacht waarschijnlijk dat het precies €90 is. Maar 90 × 1,10 = 99 dollar, dat is net te weinig. Je hebt €90,91 ≈ €91 nodig." }
      }
    },
    {
      "id": "GELD-WISSELEN-005", "familyId": "GELD-WISSELEN", "module": "Geld", "tier": 9, "levelCode": "M7", "group": 7, "skill": "geld_basis", "subSkill": "geld_valuta", "questionType": "fill_in",
      "question": "1 euro = 10 Zweedse kronen. Je hebt 250 kronen. Hoeveel euro is dat? Typ je antwoord.",
      "options": [], "correctAnswer": 0,
      "data": { "acceptedAnswers": ["25", "€25", "25 euro"], "caseSensitive": false, "placeholder": "€..." },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Kronen naar euro", "content": "1 euro = 10 kronen. Van kronen naar euro: deel door 10. 250 ÷ 10 = 25 euro.", "icon": "lightbulb" } }],
      "conceptId": "valuta_invullen", "variantIndex": 5, "citoDifficulty": 0.30, "citoDiscrimination": 0.75,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "1 euro = 10 kronen. 250 kronen ÷ 10 = 25 euro.",
        "solutionSteps": ["Wisselkoers: 1 euro = 10 kronen", "Van kronen naar euro: delen", "250 ÷ 10 = 25 euro"]
      }
    },
    {
      "id": "GELD-WISSELEN-006",
      "familyId": "GELD-WISSELEN",
      "module": "Geld",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "geld_basis",
      "subSkill": "geld_valuta",
      "questionType": "step_solver",
      "question": "Je gaat op vakantie naar Engeland. 1 pond = 1,15 euro. Je hebt €57,50. Los stap voor stap op hoeveel pond je kunt kopen.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "steps": [
          { "instruction": "Schrijf de wisselkoers op", "correctValue": "1 pond = 1,15 euro", "hint": "Wat staat er in de opgave over de wisselkoers?" },
          { "instruction": "Welke bewerking gebruik je? (× of ÷)", "correctValue": "÷", "hint": "Je gaat van euro naar pond. 1 pond kost 1,15 euro, dus je deelt." },
          { "instruction": "Reken uit: 57,50 ÷ 1,15 = ?", "correctValue": "50", "hint": "57,50 ÷ 1,15 = 5750 ÷ 115 = 50" }
        ],
        "finalAnswer": "50 pond"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Van euro naar vreemde valuta", "content": "Als 1 pond = 1,15 euro, dan kost elk pond 1,15 euro. Deel je euro's door de koers: 57,50 ÷ 1,15 = 50 pond.", "icon": "lightbulb" } }
      ],
      "conceptId": "valuta_step_solver",
      "variantIndex": 6,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 3 },
      "feedback": {
        "explanationText": "Stap 1: De wisselkoers is 1 pond = 1,15 euro. Stap 2: Je gaat van euro naar pond, dus je deelt. Stap 3: 57,50 ÷ 1,15 = 50 pond. Je kunt 50 pond kopen.",
        "solutionSteps": [
          "Wisselkoers: 1 pond = 1,15 euro",
          "Van euro naar pond = delen",
          "57,50 ÷ 1,15 = 50 pond"
        ]
      }
    }
  ]
}